module.exports = __webpack_public_path__ + "img/mk.6b2a0325.svg";